/* global axios */

// [xleaders] XO-06 — `conversationDisplayId`: `conversation.id` phía frontend LÀ display_id, không
// phải khoá chính (app/views/api/v1/models/_conversation.json.jbuilder).
export default {
  show(accountId, conversationDisplayId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/xleaders/conversations/${conversationDisplayId}/messenger_link`
    );
  },
};
